<script>
import Layout from '@layouts/auth'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'

import axios from 'axios'
axios.defaults.withCredentials = true;
axios.defaults.baseURL = appConfig.app_url;

export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      username: '',
      password: '',
      authError: [],
      tryingToLogIn: false,
      isAuthError: false,
    }
  },
  computed: {
    placeholders() {
      return process.env.NODE_ENV === 'production'
        ? {}
        : {
            username: '',
            password: '',
          }
    },
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.authError = []
      return axios.post('/logout').then(res => {
        return this.logIn({
          username: this.username,
          password: this.password,
        }).then((token) => {
          this.tryingToLogIn = false
          this.isAuthError = false
          // Redirect to the originally requested page, or to the home page
          this.$router.push(this.$route.query.redirectFrom || '/')
        }).catch((error) => {
          this.tryingToLogIn = false
          this.authError = {"message":["The given data was invalid."]};
          if(error.response && error.response.data && error.response.data.errors) {
            this.authError = error.response.data.errors;
          } else if(error.response && error.response.data && error.response.data.message) {
            this.authError = {"message":[error.response.data.message]};
          }
          this.isAuthError = true
        })
      }).catch((error) => { console.log('do', error); })



    },
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center w-75 m-auto">
              <a href="/">
                <span><img src="@assets/images/logo-sm-dark.png" alt="" height="21"/> </span>
                <h3 class="d-inline align-top ml-1 text-uppercase">{{app_name}}</h3>
              </a>
              <p class="text-muted mb-4 mt-3">Enter your email address and password to access the admin panel.</p>
            </div>

            <div v-if="authError" v-for="(item, index) in authError" :key="index">
              <b-alert v-model="isAuthError" v-for="(item2, index2) in item" :key="index2" variant="danger" dismissible>
                {{item2}}
              </b-alert>
            </div>

            <b-form @submit.prevent="tryToLogIn">
              <b-form-group
                id="input-group-1"
                label="Email"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="username"
                  type="email"
                  required
                  placeholder="Enter email"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Password"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  required
                  placeholder="Enter password"
                ></b-form-input>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button type="submit" variant="primary" class="btn-block"
                  ><span class="spinner-border spinner-border-sm" v-if="tryingToLogIn"></span> Log in</b-button
                >
              </b-form-group>
            </b-form>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 text-center">
            <p>
              <router-link tag="a" to="/forget-password" class="ml-1">Forgot your password?</router-link>
              </p
            >
            <p class="text-muted"
              >Don't have an account?
              <router-link tag="a" to="/register" class="text-primary font-weight-medium ml-1">Sign Up</router-link>
              </p
            >
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
